<template>
  <div class="share-container">
    <FishButton
      variante="primario"
      tamanho="medio"
      bloco
      icone="share-alt"
      :carregando="loading"
      @click="handleShare"
    >
      {{ $t('share.inviteFriends') }}
    </FishButton>
    <Transition name="dica">
      <div v-if="showTooltip" class="tooltip" role="status">
        {{ $t('share.linkCopied') }}
      </div>
    </Transition>
  </div>
</template>

<script>
import { FishButton } from '@/shared/ui';

/**
 * O botão de convidar. No telefone abre a folha de compartilhar do sistema; no desktop, onde
 * `navigator.share` não existe, copia o link e diz que copiou.
 *
 * Ele era a última peça fora do design system nesta tela: gradiente azul, pílula de 20px e
 * `border: none` — a maior distância possível da placa de madeira do resto do jogo. Hoje é o
 * `FishButton`, que já traz a arte do apertado e o som do clique (D4, UI-14).
 */
export default {
  name: 'ShareButton',
  components: { FishButton },
  props: {
    shareUrl: {
      type: String,
      required: true
    },
    shareTitle: {
      type: String,
      default: 'Jogue Fishbay comigo!'
    },
    shareText: {
      type: String,
      default: 'Use meu link de convite para começar a pescar e ganhar recompensas!'
    }
  },
  data() {
    return {
      loading: false,
      showTooltip: false,
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    }
  },
  beforeUnmount() {
    clearTimeout(this.relogioDaDica);
  },
  methods: {
    async handleShare() {
      this.loading = true;
      try {
        if (this.isMobile && navigator.share) {
          await navigator.share({
            title: this.shareTitle,
            text: this.shareText,
            url: this.shareUrl
          });
        } else {
          await navigator.clipboard.writeText(this.shareUrl);
          this.showCopyTooltip();
        }
      } catch (error) {
        console.error('Error sharing:', error);
      } finally {
        this.loading = false;
      }
    },
    showCopyTooltip() {
      this.showTooltip = true;
      clearTimeout(this.relogioDaDica);
      this.relogioDaDica = setTimeout(() => {
        this.showTooltip = false;
      }, 2000);
    }
  }
}
</script>

<style scoped>
.share-container {
  position: relative;
}

/* A dica sobe do botão. Fica em madeira com texto claro — é o único momento em que esta tela põe
 * texto sobre fundo escuro, e por isso usa a família `--texto*`, nunca a `--tinta*`. */
.tooltip {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: var(--e-1);
  padding: var(--e-1) var(--e-2);
  background: var(--madeira-escura);
  border: 2px solid var(--latao);
  border-radius: var(--r-2);
  box-shadow: var(--sombra-1);
  color: var(--texto);
  font-family: var(--fonte-display);
  font-size: var(--f-1);
  white-space: nowrap;
  pointer-events: none;
  z-index: var(--z-balao);
}

.dica-enter-active,
.dica-leave-active {
  transition: opacity var(--t-rapido) var(--curva-suave),
    transform var(--t-rapido) var(--curva-suave);
}

.dica-enter-from,
.dica-leave-to {
  opacity: 0;
  transform: translate(-50%, 4px);
}
</style>
